import React from "react";
import { Drawer } from "antd";
import { SlidersHorizontal } from "lucide-react";
import { useDashTheme } from "../hooks/useDashTheme";
import { Button } from "./primitives";
import { DashAntd } from "./DashAntd";
import { DashboardWidgetToggles } from "./DashboardWidgetToggles";

export function CustomizeDashboardDrawer({ open, onClose, widgets, onToggle, onReset, saving }) {
  const t = useDashTheme();

  return (
    <DashAntd>
      <Drawer
        title={null}
        open={open}
        onClose={onClose}
        width={400}
        destroyOnClose={false}
        styles={{
          body: { padding: 20 },
          header: { display: "none" },
        }}
      >
        <div style={{ display: "grid", gap: 16 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
              <SlidersHorizontal size={16} color={t.c.primary} />
              <span style={{ fontWeight: 750, fontSize: 16, color: t.c.text }}>Customize dashboard</span>
            </div>
            <p style={{ margin: 0, fontSize: 13, color: t.c.textSecondary, lineHeight: 1.45 }}>
              Flip a card off and it disappears for the whole org. Flip it back anytime.
            </p>
          </div>

          <DashboardWidgetToggles widgets={widgets} onToggle={onToggle} disabled={saving} />

          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
            <Button size="sm" variant="ghost" onClick={onReset} disabled={saving}>
              Show all
            </Button>
            <span style={{ fontSize: 12, color: t.c.textTertiary }}>
              {saving ? "Saving…" : "Saves instantly"}
            </span>
          </div>
        </div>
      </Drawer>
    </DashAntd>
  );
}

export default CustomizeDashboardDrawer;
